import { formatVehicleYMMT } from '@makemydeal/dr-dash-components';
import * as dealTemplateSelectors from '@makemydeal/dr-dash-store/selectors/dealTemplateSelectors';
import { getScopePaymentSummary } from '@makemydeal/dr-dash-store/selectors/scopePaymentSummary';
import * as vehicleSelectors from '@makemydeal/dr-dash-store/selectors/vehicleSelectors';
import { mapAmdToVppVehicleConditionLabel } from '@makemydeal/dr-dash-store/utils/vehicleProtectionUtils';
import type { StateTree } from '@makemydeal/dr-dash-types';
import type { AccelerateVehicleCondition } from '@makemydeal/dr-platform-types';
import type { RealState } from '@makemydeal/shared-scoped-store';
import { scopedStateSelectors } from '@makemydeal/shared-scoped-store';

export const getPrimaryScenarioSubtitle = (state: RealState): string => {
    const primary = dealTemplateSelectors.getScenarioVehicleDetails(state).find(({ isPrimary }) => isPrimary);
    if (!primary) {
        return '';
    }

    const primaryScopeState = scopedStateSelectors.getScopeStateById(state, primary.scopeId) as StateTree | undefined;
    const condition = primaryScopeState
        ? mapAmdToVppVehicleConditionLabel(vehicleSelectors.getVehicleCondition(primaryScopeState) as AccelerateVehicleCondition)
        : undefined;
    const vehicle = [condition, formatVehicleYMMT(primary)].filter(Boolean).join(' ');
    const summary =
        primary.offerType && primaryScopeState ? getScopePaymentSummary(primaryScopeState, primary.offerType, 'subtitle') : '';

    return [vehicle, summary].filter(Boolean).join(' — ');
};
